// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2r5iZ","alert":"SettungsInbox_alert__uppdh"};